import React from 'react';
import useSWR from 'swr';
import { useLocation } from 'react-router-dom';

import { Card } from '@nearst/ui';

import CustomerDetails from '../../components/CustomerDetails';
import SubscriptionDetails from '../../components/SubscriptionDetails';
import ErrorBoundary from '../../../../components/ErrorBoundary';

import { useShop } from '@services/ShopProvider';
import { getCustomer } from '@services/billing';

const BillingSettings = () => {
	const location = useLocation();

	const { shop, data } = useShop();
	const shopId = shop.id || data?.[0]?.id;
	const hasBilling = !!shop.stripeCustomerId;

	const { data: customer, mutate } = useSWR(hasBilling ? [shopId, 'customer'] : null, getCustomer);

	if (!hasBilling) {
		return (
			<p>
				We don't have any billing details for your account yet. Please contact us at{' '}
				<a href="mailto:support@near.st">support@near.st</a> to get set up.
			</p>
		);
	}

	return (
		<>
			{location.search.includes('upgradeSuccess') && (
				<Card className="upgrade-successful">
					<strong>Your plan has been upgraded 🎉</strong>
					<p>Your subscription on the new plan is now active. Please contact us if you have any questions!</p>
				</Card>
			)}

			<Card title="Payment details" sectioned>
				<ErrorBoundary>
					<CustomerDetails customer={customer} mutate={mutate} shopId={shopId} shopPlan={shop.plan} />
				</ErrorBoundary>
			</Card>

			<Card title="Subscription" sectioned>
				<ErrorBoundary>
					<SubscriptionDetails customer={customer} />
				</ErrorBoundary>
			</Card>
		</>
	);
};

export default BillingSettings;
